// Agrupacion de notificaciones en cliente. No requiere endpoints nuevos.
//
// Regla acordada: se agrupa SOLO cuando portafolio + mensaje + parametro son
// identicos, es decir cuando es el mismo aviso que llego varias veces. Si el
// parametro cambia son registros distintos, cada uno con su propio destino, y
// van en filas separadas: nunca se esconde un folio que el usuario no abrio.
//
// El grupo conserva todos los idlog para poder borrarlos juntos.

const normalizar = (valor) => String(valor === undefined || valor === null ? "" : valor).trim().toUpperCase();

/**
 * @param {Array} notificaciones listado tal como lo entrega el backend (mas reciente primero)
 * @returns {Array} mismo orden, con repeticiones e idlogs agregados
 */
export const agruparNotificaciones = (notificaciones = []) => {
    const grupos = new Map();
    if (!Array.isArray(notificaciones)) return [];

    notificaciones.forEach((notificacion) => {
        const clave = [
            normalizar(notificacion.portafolio),
            normalizar(notificacion.mensaje),
            normalizar(notificacion.parametro),
        ].join("||");

        const existente = grupos.get(clave);
        if (existente) {
            existente.repeticiones += 1;
            existente.idlogs.push(notificacion.idlog);
            return;
        }

        grupos.set(clave, {
            ...notificacion,
            claveGrupo: clave,
            repeticiones: 1,
            idlogs: [notificacion.idlog],
        });
    });

    return Array.from(grupos.values());
};

/**
 * WhatsApp se agrupa por cliente: se muestra el ultimo mensaje y el conteo.
 * Aqui la vista expandida ya existe, es el ChatScreen que abre la fila.
 */
export const agruparMensajesWhatsapp = (mensajes = []) => {
    const grupos = new Map();
    if (!Array.isArray(mensajes)) return [];

    mensajes.forEach((mensaje) => {
        const clave = normalizar(mensaje.numeroTelefono || mensaje.cliente);

        const existente = grupos.get(clave);
        if (existente) {
            existente.repeticiones += 1;
            existente.idsMensaje.push(mensaje.idMensaje);
            return;
        }

        grupos.set(clave, {
            ...mensaje,
            claveGrupo: clave,
            repeticiones: 1,
            idsMensaje: [mensaje.idMensaje],
        });
    });

    return Array.from(grupos.values());
};
